import { Tabs } from '@artosera/ui';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';
import { VisuelsTab } from './VisuelsTab.js';
import { ReglagesNewsletterTab } from './ReglagesNewsletterTab.js';
import { CampagnesTab } from './CampagnesTab.js';
import { VueEnsembleTab } from './VueEnsembleTab.js';
import { ListesTab } from './ListesTab.js';
import styles from './NewsletterPage.module.css';
export function NewsletterPage() {
  const { t } = useTranslation(['regie', 'commun']);
  const [params, setParams] = useSearchParams();
  return (
    <div className={styles.page} data-ui="newsletter-page">
      <header data-ui="page-header">
        <h1>{t('commun:navigation.newsletter')}</h1>
        <p>{t('regie:newsletter.sousTitre')}</p>
      </header>
      <Tabs
        value={params.get('onglet') ?? 'vue'}
        onValueChange={(v) => setParams({ onglet: v })}
        tabs={[
          {
            value: 'vue',
            label: t('regie:newsletter.onglets.vue'),
            content: <VueEnsembleTab onOuvrir={(onglet) => setParams({ onglet })} />,
          },
          {
            value: 'campagnes',
            label: t('regie:newsletter.onglets.campagnes'),
            content: <CampagnesTab />,
          },
          { value: 'listes', label: t('regie:newsletter.onglets.listes'), content: <ListesTab /> },
          {
            value: 'visuels',
            label: t('regie:newsletter.onglets.visuels'),
            content: <VisuelsTab />,
          },
          {
            value: 'reglages',
            label: t('regie:newsletter.onglets.reglages'),
            content: <ReglagesNewsletterTab />,
          },
        ]}
      />
    </div>
  );
}
